import { Link } from "react-router-dom";
import PageHeader from "../../components/layout/PageHeader";

export default function ForgotPwd() {
  return (
    <>
      <PageHeader title="Forgot Password" crumbs={[{ label: "Forgot Password" }]} />
      <section className="section">
        <div className="container">
          <div className="auth-wrap">
            <h2>Reset Password</h2>
            <p className="sub">Enter your email to receive a reset link</p>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="field">
                <label>Email Address</label>
                <input type="email" placeholder="you@example.com" required />
              </div>
              <button type="submit" className="btn btn-primary btn-block">Send Reset Link</button>
            </form>
            <p className="auth-alt">
              Remember your password? <Link to="/login">Login</Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
